import globalAxios from "../../../util/Api";
import { GET_PUBLIC_HOLIDAYS, HOLIDAY_ERROR, START_LOADING, STOP_LOADING } from "./types";
import { LogoutAction } from "../../../actions";

export const GetPublicHolidays = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/public_holidays`)
      .then(res => {
        const newres = res.data.public_holidays.map(obj => {
          obj['title'] = obj['holidayname']
          obj['start'] = obj['date']
          obj['end'] = obj['date']
          delete obj['holidayname']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_PUBLIC_HOLIDAYS, payload: newres })
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: HOLIDAY_ERROR, payload: err.response.data })
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const CreateHoliday = (date, name) => {
  let bodyFormData = new FormData();
  bodyFormData.append('public_holiday[date]', date);
  bodyFormData.append('public_holiday[holidayname]', name);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/public_holidays`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch(GetPublicHolidays())
        }
      }).catch(err => {

      })
  }
}
export const EditHoliday = (id, date, name) => {
  let bodyFormData = new FormData();
  bodyFormData.append('public_holiday[date]', date);
  bodyFormData.append('public_holiday[holidayname]', name);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/public_holidays/${id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch(GetPublicHolidays())
        }
      }).catch(err => {

      })
  }
}
export const DeleteHoliday = (id) => {

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/public_holidays/${id}`)
      .then(res => {
        if (res) {
          dispatch(GetPublicHolidays())
        }
      }).catch(err => {

      })
  }
}
